/**
 * Main.js
 *
 * @since 1.0.0
 */

import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import LazyLoadBackground from './modules/LazyLoadBackground'
// import PageHeader from './modules/PageHeader'
import DropdownMenu from './modules/DropdownMenu'
import ScrollMonitor from './modules/ScrollMonitor'
import Video from './modules/Video'
import SendForm from './modules/SendForm'
import UploadButton from './modules/UploadButton'
import SmoothScroll from './modules/SmoothScroll'
import VideoBlock from './modules/VideoBlock'
import Lightbox from './modules/Lightbox'
import SwipeOneSlider from './modules/SwipeOneSlider'
import DependsOn from './modules/DependsOn'
import ExpandableText from './modules/ExpandableText'
import CategoryToggle from './modules/CategoryToggle'

(function IIFE () {
    ObserveFontFace()
    FormValidation()
    LazyLoadBackground()
    // PageHeader()

    window.addEventListener('DOMContentLoaded', function() {
        ScrollMonitor()
    });

    Video()
    SendForm()
    UploadButton()
    SmoothScroll()
    DropdownMenu()
    VideoBlock()
    Lightbox()
    SwipeOneSlider()
    DependsOn()
    ExpandableText()
    CategoryToggle()
})()

// WEBPACK FOOTER //
// ./src/js/main.js
